//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"ApplyCutout",1,0],[0,"ApplyElectricalTopologyPathStyle",1,0],[0,"ApplyJumpPathStyle",1,0],[0,"ApplyTranslucencyToExistingObjects",1,0],[0,"CurrentDiscipline",1,0],[0,"DisciplineIndex",1,0],[0,"DisplayConnectedPorts",1,0],[0,"ElectricalTopologyPathColor",1,0],[0,"ElectricalTopologyPathStyle",1,0],[0,"ElectricalTopologyPathWidth",1,0],[0,"InsulationTranslucency",1,0],[0,"JumpPathColor",1,0],[0,"JumpPathStyle",1,0],[0,"JumpPathWidth",1,0],[0,"OffsetExpressionString",1,0],[0,"PortLength",1,0],[0,"SpaceReservationTranslucency",1,0],[0,"SplitPathOnPlacement",1,0],[0,"StockComponentFolder",1,0],[0,"StockTranslucency",1,0],[0,"SubdivideSegmentForFixturePartPlacement",1,1],[0,"UsePreferredPortPlacement",1,0]],[[["numDisciplines"],"GetAllAvailableDisciplines",{R_:{disciplines:""}},0,0]],[]];
SPLM.Preferences.RoutingPreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RoutingPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;